var chunkMapping = {
	"src_bootstrap_ts": [
		64736
	],
	"webpack_container_remote_social_SocialProfile": [
		4157
	],
	"webpack_container_remote_social_EditSocialProfilePage": [
		29968
	],
	"webpack_container_remote_social_BlockedUsersList": [
		87874
	],
	"webpack_container_remote_account_forms_fields_password_getFormPasswordValidator": [
		69989
	],
	"webpack_container_remote_social_UserAvatar": [
		75457
	],
	"webpack_container_remote_social_UseSocialUser": [
		88350
	],
	"webpack_container_remote_tickets_TicketsWidget": [
		24762
	],
	"webpack_container_remote_social_ProfileImageEdit": [
		63348
	],
	"webpack_container_remote_social_EditSocialBanner": [
		47126
	],
	"webpack_container_remote_social_PrivateChat": [
		2315
	],
	"webpack_container_remote_tickets_UseTicketSubmit": [
		27834
	],
	"webpack_container_remote_tickets_CheckTicket": [
		26802
	],
	"webpack_container_remote_social_UseSocialRoute": [
		10533
	],
	"webpack_container_remote_account_countries_ro_RegisterContainer": [
		79937
	],
	"webpack_container_remote_gaming_FreeToPlayGameBase": [
		67475
	],
	"webpack_container_remote_gaming_UsingXJackpotDetails": [
		75424
	],
	"webpack_container_remote_stats_getSportIds": [
		10453
	],
	"src_federations_account_modals_resetPassword_ResetPasswordContainerModal_vue": [
		15798,
		2624
	],
	"src_federations_account_modules_responsibleGaming_components_canon_modals_CloseAccountSecurit-bf99cf": [
		61045
	],
	"src_federations_account_modals_survey_SurveyModal_vue": [
		72601
	],
	"webpack_container_remote_gaming_initializeFederation": [
		28910
	],
	"webpack_container_remote_social_initializeFederation": [
		3229
	],
	"webpack_container_remote_shops_initializeShops": [
		22669
	],
	"webpack_container_remote_tickets_initializeFederation": [
		89360
	],
	"webpack_container_remote_account_initializeFederation": [
		9221
	],
	"webpack_container_remote_gaming_GamesPage": [
		81111
	],
	"webpack_container_remote_gaming_EmbeddableSection": [
		62966
	],
	"webpack_container_remote_social_SocialAppBannerHome": [
		19318
	],
	"webpack_container_remote_social_DiscoverTickets": [
		52682
	],
	"webpack_container_remote_social_NewsCarousel": [
		18620
	],
	"webpack_container_remote_social_ExploreVideoThumbnailList": [
		85014
	],
	"webpack_container_remote_social_ExploreTicketsHome": [
		26884
	],
	"webpack_container_remote_account_modules_onboarding_components_PE123OnboardingChallengeTracker": [
		56766
	],
	"webpack_container_remote_stats_StreamsAndVisualizationsOverlay": [
		25774
	],
	"webpack_container_remote_social_SuperSocial": [
		79617
	],
	"webpack_container_remote_gaming_FreeToPlayEligibilityChecker": [
		74390
	],
	"webpack_container_remote_stats_EventDetailsScoreboardAndSubnav": [
		65795
	],
	"webpack_container_remote_social_MicroFeedView": [
		93780
	],
	"webpack_container_remote_tickets_UseTicketLink": [
		18389
	],
	"webpack_container_remote_account_forms_fields_SdsDateOfBirth": [
		72870
	],
	"webpack_container_remote_account_modules_general_PrivacyConsentGeneralInfo": [
		28317
	],
	"webpack_container_remote_tickets_TicketNegotiation": [
		92694
	],
	"webpack_container_remote_tickets_SuperAdvantageBetSelection": [
		41098
	],
	"webpack_container_remote_tickets_BetPlacedOverlay": [
		96831
	],
	"webpack_container_remote_social_ArticlesContent": [
		37541
	],
	"webpack_container_remote_social_NewsContainer": [
		66529
	],
	"webpack_container_remote_account_countries_be_RegisterContainerItsMe": [
		42647
	],
	"webpack_container_remote_tickets_SuperAdvantageTournament": [
		4776
	],
	"webpack_container_remote_social_NotificationList": [
		96324
	],
	"webpack_container_remote_social_UseSocialAuthGuard": [
		94801
	],
	"webpack_container_remote_account_modals_pl_CompleteRegistrationModal": [
		98197
	],
	"webpack_container_remote_tickets_UseSuperAdvantageMarket": [
		25998
	],
	"webpack_container_remote_stats_StatsProvider": [
		15085
	],
	"webpack_container_remote_stats_SelectedTabContent": [
		91678
	],
	"webpack_container_remote_social_InsightsContent": [
		88255
	],
	"webpack_container_remote_social_SocialChat": [
		35538
	],
	"webpack_container_remote_social_SocialAppBanner": [
		18781
	],
	"webpack_container_remote_social_InsightsPreview": [
		24691
	],
	"webpack_container_remote_tickets_SuperAdvantageMarket": [
		1239
	],
	"webpack_container_remote_stats_CompetitionStandings": [
		29712
	],
	"webpack_container_remote_tickets_UseActiveTicketInfo": [
		83279
	]
};
var idToExternalAndNameMapping = {
	"1239": [
		"default",
		"./SuperAdvantageMarket",
		39047
	],
	"2315": [
		"default",
		"./PrivateChat",
		60152
	],
	"2624": [
		"default",
		"./forms/fields/password/validatePasswordRequirements",
		39991
	],
	"3229": [
		"default",
		"./initializeFederation",
		60152
	],
	"4157": [
		"default",
		"./SocialProfile",
		60152
	],
	"4776": [
		"default",
		"./SuperAdvantageTournament",
		39047
	],
	"9221": [
		"default",
		"./initializeFederation",
		39991
	],
	"10453": [
		"default",
		"./getSportIds",
		77927
	],
	"10533": [
		"default",
		"./UseSocialRoute",
		60152
	],
	"15085": [
		"default",
		"./StatsProvider",
		77927
	],
	"15798": [
		"default",
		"./forms/fields/password/calculatePasswordRequirementsProgress",
		39991
	],
	"18389": [
		"default",
		"./UseTicketLink",
		39047
	],
	"18620": [
		"default",
		"./NewsCarousel",
		60152
	],
	"18781": [
		"default",
		"./SocialAppBanner",
		60152
	],
	"19318": [
		"default",
		"./SocialAppBannerHome",
		60152
	],
	"22669": [
		"default",
		"./initializeShops",
		40829
	],
	"24691": [
		"default",
		"./InsightsPreview",
		60152
	],
	"24762": [
		"default",
		"./TicketsWidget",
		39047
	],
	"25774": [
		"default",
		"./StreamsAndVisualizationsOverlay",
		77927
	],
	"25998": [
		"default",
		"./UseSuperAdvantageMarket",
		39047
	],
	"26802": [
		"default",
		"./CheckTicket",
		39047
	],
	"26884": [
		"default",
		"./ExploreTicketsHome",
		60152
	],
	"27834": [
		"default",
		"./UseTicketSubmit",
		39047
	],
	"28317": [
		"default",
		"./modules/general/PrivacyConsentGeneralInfo",
		39991
	],
	"28910": [
		"default",
		"./initializeFederation",
		30460
	],
	"29712": [
		"default",
		"./CompetitionStandings",
		77927
	],
	"29968": [
		"default",
		"./EditSocialProfilePage",
		60152
	],
	"35538": [
		"default",
		"./SocialChat",
		60152
	],
	"37541": [
		"default",
		"./ArticlesContent",
		60152
	],
	"41098": [
		"default",
		"./SuperAdvantageBetSelection",
		39047
	],
	"42647": [
		"default",
		"./countries/be/RegisterContainerItsMe",
		39991
	],
	"47126": [
		"default",
		"./EditSocialBanner",
		60152
	],
	"52682": [
		"default",
		"./DiscoverTickets",
		60152
	],
	"56766": [
		"default",
		"./modules/onboarding/components/PE123OnboardingChallengeTracker",
		39991
	],
	"61045": [
		"default",
		"./forms/fields/SbPassword",
		39991
	],
	"62966": [
		"default",
		"./EmbeddableSection",
		30460
	],
	"63348": [
		"default",
		"./ProfileImageEdit",
		60152
	],
	"64736": [
		"default",
		"./modules/registration/useResendEmail",
		39991
	],
	"65795": [
		"default",
		"./EventDetailsScoreboardAndSubnav",
		77927
	],
	"66529": [
		"default",
		"./NewsContainer",
		60152
	],
	"67475": [
		"default",
		"./FreeToPlayGameBase",
		30460
	],
	"69989": [
		"default",
		"./forms/fields/password/getFormPasswordValidator",
		39991
	],
	"72601": [
		"default",
		"./forms/fields/multistep/NumberedSteps",
		39991
	],
	"72870": [
		"default",
		"./forms/fields/SdsDateOfBirth",
		39991
	],
	"74390": [
		"default",
		"./FreeToPlayEligibilityChecker",
		30460
	],
	"75424": [
		"default",
		"./UsingXJackpotDetails",
		30460
	],
	"75457": [
		"default",
		"./UserAvatar",
		60152
	],
	"79617": [
		"default",
		"./SuperSocial",
		60152
	],
	"79937": [
		"default",
		"./countries/ro/RegisterContainer",
		39991
	],
	"81111": [
		"default",
		"./GamesPage",
		30460
	],
	"83279": [
		"default",
		"./UseActiveTicketInfo",
		39047
	],
	"85014": [
		"default",
		"./ExploreVideoThumbnailList",
		60152
	],
	"87874": [
		"default",
		"./BlockedUsersList",
		60152
	],
	"88255": [
		"default",
		"./InsightsContent",
		60152
	],
	"88350": [
		"default",
		"./UseSocialUser",
		60152
	],
	"89360": [
		"default",
		"./initializeFederation",
		39047
	],
	"91678": [
		"default",
		"./SelectedTabContent",
		77927
	],
	"92694": [
		"default",
		"./TicketNegotiation",
		39047
	],
	"93780": [
		"default",
		"./MicroFeedView",
		60152
	],
	"94801": [
		"default",
		"./UseSocialAuthGuard",
		60152
	],
	"96324": [
		"default",
		"./NotificationList",
		60152
	],
	"96831": [
		"default",
		"./BetPlacedOverlay",
		39047
	],
	"98197": [
		"default",
		"./modals/pl/CompleteRegistrationModal",
		39991
	]
};
var idToRemoteMap = {
	"1239": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"2315": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"2624": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"3229": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"4157": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"4776": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"9221": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"10453": [
		{
			"externalType": "script",
			"name": "stats",
			"externalModuleId": 77927
		}
	],
	"10533": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"15085": [
		{
			"externalType": "script",
			"name": "stats",
			"externalModuleId": 77927
		}
	],
	"15798": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"18389": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"18620": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"18781": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"19318": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"22669": [
		{
			"externalType": "script",
			"name": "shops",
			"externalModuleId": 40829
		}
	],
	"24691": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"24762": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"25774": [
		{
			"externalType": "script",
			"name": "stats",
			"externalModuleId": 77927
		}
	],
	"25998": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"26802": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"26884": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"27834": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"28317": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"28910": [
		{
			"externalType": "script",
			"name": "gaming",
			"externalModuleId": 30460
		}
	],
	"29712": [
		{
			"externalType": "script",
			"name": "stats",
			"externalModuleId": 77927
		}
	],
	"29968": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"35538": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"37541": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"41098": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"42647": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"47126": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"52682": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"56766": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"61045": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"62966": [
		{
			"externalType": "script",
			"name": "gaming",
			"externalModuleId": 30460
		}
	],
	"63348": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"64736": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"65795": [
		{
			"externalType": "script",
			"name": "stats",
			"externalModuleId": 77927
		}
	],
	"66529": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"67475": [
		{
			"externalType": "script",
			"name": "gaming",
			"externalModuleId": 30460
		}
	],
	"69989": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"72601": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"72870": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"74390": [
		{
			"externalType": "script",
			"name": "gaming",
			"externalModuleId": 30460
		}
	],
	"75424": [
		{
			"externalType": "script",
			"name": "gaming",
			"externalModuleId": 30460
		}
	],
	"75457": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"79617": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"79937": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	],
	"81111": [
		{
			"externalType": "script",
			"name": "gaming",
			"externalModuleId": 30460
		}
	],
	"83279": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"85014": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"87874": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"88255": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"88350": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"89360": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"91678": [
		{
			"externalType": "script",
			"name": "stats",
			"externalModuleId": 77927
		}
	],
	"92694": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"93780": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"94801": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"96324": [
		{
			"externalType": "script",
			"name": "social",
			"externalModuleId": 60152
		}
	],
	"96831": [
		{
			"externalType": "script",
			"name": "tickets",
			"externalModuleId": 39047
		}
	],
	"98197": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 39991
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}